import toCamelCase from './utilities/to-camel-case';

import Countdown from '../components/eng-ms-countdown/scripts/countdown';
import NumberRoll from '../components/eng-ms-squad-stats/scripts/squad-stats';
import SquadNav from '../components/eng-ms-squad-nav/scripts/squad-nav';
import ScrollToSection from '../components/eng-ms-squad-links/scripts/scroll-to-section';
import PlayerCarousel from '../components/eng-ms-squad-stats/scripts/player-carousel';
import HeroVideoPlayer from '../components/eng-ms-squad-hero/scripts/hero-video-player';
import NewsCarousel from '../components/eng-ms-news-feature/scripts/news-feature-carousel';
import ContentTabs from '../components/eng-ms-content-tabs/scripts/content-tabs';
import TicketsInfo from '../components/eng-ms-tickets/scripts/tickets-info';
import CompetitionForm from '../components/eng-ms-competition/scripts/competition-form';
import LoadStacklaWidget from '../components/eng-ms-load-stackla-widget/scripts/load-stackla-widget';
import Modal from '../components/eng-ms-modal/scripts/modal';
import ContentToggle from '../components/eng-ms-content-toggle/scripts/content-toggle';
import VideoItem from '../components/eng-ms-video-item/scripts/video-item';
import SocialShare from '../components/eng-ms-social-share/scripts/social-share';
import Duplicate from '../components/eng-ms-duplicate/scripts/duplicate';
import LoadOptaWidget from '../components/eng-ms-load-opta-widget/scripts/load-opta-widget';
import ImageCaptions from '../components/eng-ms-image-captions/scripts/image-captions';
import EnglandSupportersPolls from '../components/esc-redesign/scripts/esc-polls';

import '../styles/eng-ms.scss';

class App {
    constructor(config) {
        this.mount = document.querySelector(config.mount) || '';
        this.components = config.components || {};

        this.initComponents();
    }

    initComponents(target = this.mount) {
        if (!target) {
            return;
        }

        [...target.querySelectorAll('[data-component]')].forEach((domElement) => {
            const element = domElement;
            // find the components required for this element
            const componentsRequired = element.dataset.component.split(' ');

            // keep track of the components already initialised
            if (!element.initalisedComponents) {
                element.initalisedComponents = {};
            }

            // Initalise components
            componentsRequired.forEach((component) => {
                // Has the required component already been initalised?
                if (element.initalisedComponents[component]) {
                    console.warn(`The ${component} component for this element has already been initalised.`);
                    return;
                }

                // Is the component Class available for initalisation?
                const Module = this.components[toCamelCase(component)];
                if (Module) {
                    // Initalise component and save the reference to it on the target
                    const moduleInstance = new Module({
                        mount: this.mount,
                        root: element
                    });
                    element.initalisedComponents[component] = moduleInstance;
                } else {
                    console.warn(`The ${component} component has been found on page but is no corresponding component was found in src/js/components/`);
                }
            });
        });
    }
}

const app = new App({
    components: {
        numberRoll: NumberRoll,
        countdown: Countdown,
        playerCarousel: PlayerCarousel,
        scrollToSection: ScrollToSection,
        squadNav: SquadNav,
        heroVideoPlayer: HeroVideoPlayer,
        newsCarousel: NewsCarousel,
        contentTabs: ContentTabs,
        ticketsInfo: TicketsInfo,
        competitionForm: CompetitionForm,
        loadStacklaWidget: LoadStacklaWidget,
        modal: Modal,
        contentToggle: ContentToggle,
        videoItem: VideoItem,
        socialShare: SocialShare,
        duplicate: Duplicate,
        loadOptaWidget: LoadOptaWidget,
        imageCaptions: ImageCaptions,
        englandSupportersPolls: EnglandSupportersPolls
    },
    mount: '#mount'
});

export default app;



// WEBPACK FOOTER //
// ./scripts/index.js